import { TypeReference } from '@lg/shared'
import { ErrorService } from '@lg/ng-shared'
import { Injectable } from '@angular/core'
import { BehaviorSubject } from 'rxjs'
import type { BranchNameType, BusinessObjectTypeType } from '@lg/shared'
import { StudioTrpcService } from '@lg/ng-shared'

@Injectable({
	providedIn: 'root',
})
export class EditorService {
	private readonly typeReferencesSubject = new BehaviorSubject<TypeReference[]>(
		[],
	)
	public typeReferences$ = this.typeReferencesSubject.asObservable()
	private isTypeReferencesLoaded = false
	private isTypeReferencesLoading = false

	constructor(private trpcService: StudioTrpcService) {}

	async loadTypeReferences(
		branchName: BranchNameType,
		boTypes: '*' | BusinessObjectTypeType[],
		forceReload: boolean,
	) {
		if (this.isTypeReferencesLoading) return
		if (this.isTypeReferencesLoaded && !forceReload) return

		this.isTypeReferencesLoading = true
		const typeReferences =
			await this.trpcService.client.bo.getTypeReferences.query({
				branchName,
				boTypes,
				includePrimitives: true,
			})
		this.isTypeReferencesLoading = false

		if (typeReferences) {
			this.isTypeReferencesLoaded = true
			this.typeReferencesSubject.next(
				typeReferences as any as TypeReference[], //.map((typeRef) => new TypeReference(typeRef)),
			)
		}
	}
}
